import styled, { css } from 'styled-components';

import { StyledButton } from '../Button/Button';
import { buttonBase, buttonSizes, buttonVariants, resetBrowserButton } from '../Button/styles';
import { anchorPresets, anchorVariants } from '../Anchor/styles';

import { bannerTokens } from '../../tokens/components/Banner/tokens';

const bannerVariants = {
  error: bannerTokens.ContainerBackgroundColorNegativeDefault,
  info: bannerTokens.ContainerBackgroundColorInformationalDefault,
  setup: bannerTokens.ContainerBackgroundColorNoticeDefault,
  staff: bannerTokens.ContainerBackgroundColorStaffDefault,
  success: bannerTokens.ContainerBackgroundColorPositiveDefault,
  warning: bannerTokens.ContainerBackgroundColorNoticeDefault,
} as const;

const bannerBase = css`
  border-radius: ${bannerTokens.ContainerBorderRadiusBaseDefault};
  display: flex;
  justify-content: space-between;
  overflow-wrap: break-word;
  word-break: break-word;
  color: ${bannerTokens.ContainerFontColorBaseDefault};
  padding: ${bannerTokens.ContainerSpacingInnerVerticalBaseDefault}
    ${bannerTokens.ContainerSpacingInnerHorizontalBaseDefault};
`;

export const BannerContentWrapper = styled.div`
  align-items: center;
  color: ${bannerTokens.ContentTitleFontColorBaseDefault};
  display: flex;
  gap: ${bannerTokens.ContentSpacingOuterHorizontalBaseDefault};

  ${({ theme }) =>
    theme.bannerMobile &&
    css`
      align-items: flex-start;
      flex-direction: column;
    `};
`;

export const BannerHeaderWrapper = styled.div`
  ${({ theme }) =>
    theme.bannerMobile &&
    css`
      display: flex;
      justify-content: space-between;
      width: 100%;
    `}
`;

export const BannerContentBody = styled.div`
  // Links that appear in the body
  a,
  ${StyledButton} {
    ${anchorVariants.underline};
  }
`;

export const BannerContentFooter = styled.div`
  margin-top: 8px;
`;

export const BannerDismissAction = styled.button`
  ${resetBrowserButton};
  align-items: center;
  align-self: flex-start;
  border-radius: 50%;
  color: ${bannerTokens.CloseActionColorBaseDefault};
  display: inline-flex;
  justify-content: center;
  margin-left: ${bannerTokens.ContentSpacingOuterHorizontalBaseDefault};
  min-height: ${bannerTokens.CloseActionSizeBaseDefault};
  min-width: ${bannerTokens.CloseActionSizeBaseDefault};

  &:hover {
    cursor: pointer;
    background: ${bannerTokens.CloseActionBackgroundColorBaseDefaultHover};
  }

  &:active {
    cursor: pointer;
    background: ${bannerTokens.CloseActionBackgroundColorBaseDefaultDown};
  }

  &:focus-visible {
    box-shadow: none;
    outline: ${bannerTokens.CloseActionOutlineStrokeBaseKeyboardFocus}
      ${bannerTokens.CloseActionOutlineColorBaseKeyboardFocus};
    outline-offset: ${bannerTokens.CloseActionOutlineOffsetBaseKeyboardFocus};
  }
`;

const bannerActions = css`
  ${buttonBase};
  ${({ theme }) => theme.buttonSize && buttonSizes[theme.buttonSize]};
  ${({ theme }) => theme.buttonPreset && anchorPresets[theme.buttonPreset]};
`;

export const BannerPrimaryAction = styled.button`
  ${bannerActions};
  ${buttonVariants.default};
`;

export const BannerSecondaryAction = styled.button`
  ${bannerActions};
  ${buttonVariants.transparent};
`;

export const StyledBanner = styled.div`
  ${bannerBase};
  ${({ theme }) =>
    css`
      background-color: ${bannerVariants[theme.bannerType]};
    `};
`;
